import { SvgIcon } from '@mui/material';
import React from 'react';

/**
 * Logo TikTok Shop (marketplace) – logo officiel avec couleurs cyan et rose.
 * Source : TikTok Shop logo (couleurs officielles #25f4ee cyan, #fe2c55 rose).
 */
const TiktokShopIcon = (props) => {
  return (
    <SvgIcon viewBox="0 0 372.04 66.9" {...props}>
      <defs>
        <clipPath id="tiktok-shop-clip" clipPathUnits="userSpaceOnUse">
          <rect x="-1.68" y="-8.93" width="373.72" height="95.3" fill="none" />
        </clipPath>
      </defs>
      <g style={{ isolation: 'isolate' }}>
        <g clipPath="url(#tiktok-shop-clip)">
          <path
            fill="#000000"
            d="M352.28,47.37a8.54,8.54,0,0,0,6,2.26,8.2,8.2,0,0,0,8.53-8.58,8.68,8.68,0,0,0-2.48-6.38,8.17,8.17,0,0,0-6-2.48,8.41,8.41,0,0,0-8.64,8.86A8,8,0,0,0,352.28,47.31Zm-2.65-19.65v4.12c1.75-2.94,5.42-4.68,9.2-4.68a12.82,12.82,0,0,1,9.38,3.84,13.53,13.53,0,0,1,3.84,10,13.36,13.36,0,0,1-3.84,9.88,12.68,12.68,0,0,1-9.38,3.78c-3.84,0-7.56-1.58-9.2-4.52v16.77h-5.14V27.72h5.14Zm-17.07,6.84a8.58,8.58,0,0,0-6.16-2.37,8.79,8.79,0,0,0-6.21,2.37,8.33,8.33,0,0,0-2.48,6.27,8.73,8.73,0,0,0,2.48,6.44,8.6,8.6,0,0,0,6.21,2.43,8.4,8.4,0,0,0,6.16-2.43,8.54,8.54,0,0,0,2.54-6.43,8.18,8.18,0,0,0-2.54-6.27Zm-16-3.62a14.65,14.65,0,0,1,19.65,0,13.06,13.06,0,0,1,4,9.88,13.22,13.22,0,0,1-4.07,10,14.34,14.34,0,0,1-19.54,0,13.23,13.23,0,0,1-4-10,13,13,0,0,1,4-9.88ZM289.45,54.06h-5.14V13.36h5.14v18.3a7,7,0,0,1,3.61-3.33,12.3,12.3,0,0,1,5.08-1.19c6.6,0,10.73,4.29,10.67,11.69V54.06h-5.14V39.19c0-4.29-2.54-7-6.21-7a8.73,8.73,0,0,0-5.59,1.92c-1.64,1.24-2.43,3.16-2.43,5.76V54.06ZM258.34,42.85a6.63,6.63,0,0,0,2.43,4.8,8.55,8.55,0,0,0,5.93,2.09c4.69,0,7.34-2.48,7.85-5.7.28-3.84-2.54-6-6.61-6.94l-5-1.24q-9.48-2.46-9.48-10.16a9.66,9.66,0,0,1,3.73-7.85,13.26,13.26,0,0,1,8.87-3.1,13.1,13.1,0,0,1,9,3.16,10.4,10.4,0,0,1,3.56,8.24h-5.25c0-3.84-3-6.38-7.34-6.38a8.46,8.46,0,0,0-5.14,1.64,5.08,5.08,0,0,0-2.15,4.23c0,2.71,1.86,4.52,5.53,5.42l5.08,1.24c7.39,1.86,11.12,6.1,10.39,12.2a10.82,10.82,0,0,1-4,7.28,13.6,13.6,0,0,1-9,2.88,14,14,0,0,1-9.71-3.5,10.92,10.92,0,0,1-3.9-8.3h5.25Z"
          />
          <path
            fill="#25f4ee"
            d="M20.49,23.56v-2.42a18.1,18.1,0,0,0-2.44-.18,18.05,18.05,0,0,0-10.35,32.85l-.25-.27a17.92,17.92,0,0,1-4.49-12,17.9,17.9,0,0,1,17.52-17.95Z"
          />
          <path
            fill="#25f4ee"
            d="M49.77,15.99v-2.34a13.56,13.56,0,0,1-7.43-2.21,13.91,13.91,0,0,0,7.43,4.56Zm-28.85,33.83a8.37,8.37,0,0,0,8.3-8l0-39.25h7.12v-.09a13.58,13.58,0,0,1-.23-2.49h-9.81l0,39.32a8.23,8.23,0,0,1-12.06,7,8.3,8.3,0,0,0,6.69,3.51Z"
          />
          <path
            fill="#fe2c55"
            d="M18.04,30.69a8.27,8.27,0,0,0-3.82,15.62,8,8,0,0,1-1.56-4.81,8.2,8.2,0,0,1,10.68-7.87v-10a18.06,18.06,0,0,0-2.43-.18h-.49V31.06a7.56,7.56,0,0,0-2.36-.34Zm24.28-19.25a13.17,13.17,0,0,1-3.36-8.95h-2.7a13.78,13.78,0,0,0,6.05,8.95Z"
          />
          <path
            fill="#fe2c55"
            d="M49.77,15.84h-.05l0,7.56A22.76,22.76,0,0,1,36.04,18.96V39.06a18,18,0,0,1-18,18,17.48,17.48,0,0,1-10.35-3.2,17.29,17.29,0,0,0,13.21,5.76,18.08,18.08,0,0,0,18.06-18.06V21.56a22.79,22.79,0,0,0,13.65,4.39v-9.81a13.9,13.9,0,0,1-2.86-.3Z"
          />
          <path
            fill="#000000"
            d="M97.32,24.42A4.69,4.69,0,1,0,94.04,23.06,4.52,4.52,0,0,0,97.32,24.42Zm107-9.49h9.3v18.19l9.22-9.05h11.11l-11.67,11.32L235.31,54.06H225.05l-8.72-13-2.76,2.68V54.06h-9.3V14.93h0Zm-98.61,0h9.31v18.19l9.22-9.05h11.11L123.64,35.39,136.71,54.06H126.45l-8.72-13-2.76,2.68V54.06h-9.3V14.93h0Zm-13,12.53h9.32V54.06h-9.25l-.06-26.63ZM138.49,15.06h29.73l-2.67,8.32h-8.19V54.06h-9.41V23.35l-9.45,0V15.06Zm-76.66,0h29.06l-2.67,8.32h-7.54V54.06h-9.4V23.35l-9.45,0V15.06Zm-25.71,24V19.06a22.78,22.78,0,0,0,13.65,4.39v-7.62a13.31,13.31,0,0,1-7.43-4.4,13.14,13.14,0,0,1-6-8.95h-7.19l0,39.32a8.25,8.25,0,0,1-8.23,7.94,7.81,7.81,0,0,1-6.69-3.44A8.25,8.25,0,0,1,18.04,30.76a8.13,8.13,0,0,1,2.44.38v-7.69a18,18,0,0,0-12.79,30.35A17.55,17.55,0,0,0,18.04,57.06,18.08,18.08,0,0,0,36.1,39Z"
          />
          <path
            fill="#25f4ee"
            d="M167.04,38.15a15.93,15.93,0,0,1,14.69-15.89q-.7-.05-1.4-.05a15.94,15.94,0,0,0,0,31.88c.42,0,1,0,1.4-.05A15.94,15.94,0,0,1,167.04,38.15Z"
          />
          <path
            fill="#fe2c55"
            d="M185.34,22.21c-.42,0-1,0-1.41.05a15.94,15.94,0,0,1,0,31.77c.42,0,1,.05,1.41.05a15.94,15.94,0,0,0,0-31.88Z"
          />
          <path
            fill="#000000"
            d="M182.83,45.9a7.75,7.75,0,1,1,3-.59A7.68,7.68,0,0,1,182.83,45.9Zm0-23.69a15.94,15.94,0,1,0,6.1,1.21,15.79,15.79,0,0,0-6.1-1.21Z"
          />
        </g>
      </g>
    </SvgIcon>
  );
};

export default TiktokShopIcon;
